import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "product-family__img-wrap" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "product-family__finish-coming-soon"
}
const _hoisted_5 = { class: "product-family__category-card-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`product-family__category-card`, $props.portfolio && `product-family__category-card--${$props.portfolio}`])
  }, [
    _createElementVNode("a", {
      href: $props.productFilteringUrl,
      class: _normalizeClass([`product-family__category-card-link`, $props.isFinishImageMissing && `state-finish-image-missing`])
    }, [
      _createElementVNode("div", _hoisted_2, [
        ($props.imageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: `${$props.imageUrl}?wid=400&hei=400`,
              alt: $props.displayName,
              class: "product-family__category-card-image"
            }, null, 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true),
        ($props.isFinishImageMissing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.translations.NoVariantImage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString($props.displayName), 1 /* TEXT */)
    ], 10 /* CLASS, PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}